import Vue from 'vue'
import draggable from 'vuedraggable'

Vue.component("v-draggable", draggable)